/**
 * FAQ Section (Aqua)
 * Smooth accordion functionality with open/close animations
 */

(function() {
  'use strict';

  function initFAQ() {
    const faqItems = document.querySelectorAll('[data-faq-item]');

    faqItems.forEach(item => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!trigger || !content) return;

      // Handle click
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('faq-item--open');

        // Toggle open/close
        if (isOpen) {
          closeFAQ(item, trigger, content);
        } else {
          openFAQ(item, trigger, content);
        }
      });

      // Set initial height for items that are open by default
      if (item.classList.contains('faq-item--open')) {
        requestAnimationFrame(() => {
          const answer = content.querySelector('.faq-item__answer');
          if (answer) {
            content.style.maxHeight = answer.scrollHeight + 'px';
          }
        });
      }
    });
  }

  function openFAQ(item, trigger, content) {
    item.classList.add('faq-item--open');
    trigger.setAttribute('aria-expanded', 'true');

    // Set max-height to actual content height for smooth transition
    const answer = content.querySelector('.faq-item__answer');
    if (answer) {
      content.style.maxHeight = answer.scrollHeight + 'px';
    }
  }

  function closeFAQ(item, trigger, content) {
    item.classList.remove('faq-item--open');
    trigger.setAttribute('aria-expanded', 'false');

    // Reset max-height for smooth collapse
    content.style.maxHeight = '0';
  }

  // Initialize on load
  function init() {
    initFAQ();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.faq-section')) {
      setTimeout(init, 100);
    }
  });
})();
